<h1 class="mb-4">Szczegóły regulaminu</h1>

<p-tabs value="0" lazy [class]="'customTab rule-details-tabs'">
  <p-tablist>
    <p-tab value="0">Dane podstawowe</p-tab>
    <p-tab value="1">Historia zdarzeń</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      @if (rule()) {
        <app-admin-panel-rule-details-basic [rule]="rule()!" />
      }
    </p-tabpanel>
    <p-tabpanel value="1"
      ><app-admin-panel-rule-details-history [rule]="rule()!"
    /></p-tabpanel>
  </p-tabpanels>
</p-tabs>
